import { Check } from "lucide-react";
import { useEffect, useRef, useState } from "react";

import type { ShareTarget } from "./link-meta";

const COPIED_FEEDBACK_MS = 1400;

export function CopyEmailButton({ email, service }: ShareTarget) {
  const [isCopied, setIsCopied] = useState(false);
  const resetTimer = useRef(0);

  useEffect(() => () => window.clearTimeout(resetTimer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(email);
    } catch {
      return;
    }

    setIsCopied(true);
    window.clearTimeout(resetTimer.current);
    resetTimer.current = window.setTimeout(
      () => setIsCopied(false),
      COPIED_FEEDBACK_MS,
    );
  };

  return (
    <button
      aria-label={`Copy ${service} email`}
      className="inline-flex cursor-pointer items-center gap-xs rounded-xs px-xxs text-[13px] font-semibold text-text-brand-primary outline-hidden hover:underline focus-visible:ring-2 focus-visible:ring-fg-brand-primary"
      onClick={() => void copy()}
      type="button"
    >
      {isCopied ? (
        <>
          <Check className="size-3.5" />
          Copied
        </>
      ) : (
        "Copy email"
      )}
    </button>
  );
}
